module.exports = require('./_global');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.1@core-js/modules/_path.js
// module id = 135
// module chunks = 0